/* 🤖 this file was generated by svg-to-ts */
export const matIconKeyboardOptionKey: {
  name: 'keyboard-option-key';
  data: string;
} = {
  name: 'keyboard-option-key',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M15 5h6v2h-6zM9 5H3v2h4.85l6.92 12H21v-2h-5.07z"/></svg>`
};
